import { useLazyQuery, useMutation } from "@apollo/client/react"; import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material';

import { useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import { FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Tooltip } from '@mui/material';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { adaptPeriodosArray, GET_ALL_PERIODOS } from "../../../data/graphQL/queries/Periodos/getAllPeriodos";
import { CustomButton } from '../../../components/customButton/CustomButton';
import moment from 'moment';
import { adaptCierrePeriodo, CONSULTAR_CIERRE_PERIODO } from '../../../data/graphQL/queries/Periodos/consultarCierrePeriodo';
import './gestionPeriodoContent.scss';
import { ConexionesPendientesDialog } from './ConexionesPendientesDialog';
import { CerrarPeriodoDialog } from './CerrarPeriodoDialog';
import { GestionPeriodoCreationModal } from './GestionPeriodoCreationModal';
import EditIcon from '@mui/icons-material/Edit';
import { EditPeriodoDialog } from "./EditPeriodoDialog";
import { EDITAR_PERIODO } from "../../../data/graphQL/mutations/GestionPeriodo/saveGestionPeriodo";

const meses = [
  { id: 1, displayName: 'Enero' },
  { id: 2, displayName: 'Febrero' },
  { id: 3, displayName: 'Marzo' },
  { id: 4, displayName: 'Abril' },
  { id: 5, displayName: 'Mayo' },
  { id: 6, displayName: 'Junio' },
  { id: 7, displayName: 'Julio' },
  { id: 8, displayName: 'Agosto' },
  { id: 9, displayName: 'Septiembre' },
  { id: 10, displayName: 'Octubre' },
  { id: 11, displayName: 'Noviembre' },
  { id: 12, displayName: 'Diciembre' }];


const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 2018 + 1 }, (_, i) => {
  const year = 2018 + i;
  return { id: year, displayName: year.toString() };
});

export const GestionPeriodosContent = ({ setChildrenAction }) => {
  const location = useLocation();

  const rutasStorage = localStorage.getItem('navigationRoutes');
  const [allowedWrite, setAllowedWrite] = useState(false);

  const [conexionesPendientes, setConexionesPendientes] = useState([]);
  const [fechaEmpalmePeriodo, setFechaEmpalmePeriodo] = useState(null);
  const [idPeriodoActivo, setIdPeriodoActivo] = useState(null);

  const [openModal, setOpenModal] = useState(false);
  const [openModalCierre, setOpenModalCierre] = useState(false);
  const [editPeriodo, setEditPeriodo] = useState({ periodo: null, open: false });

  const [editarPeriodo, { loading: edicionLoading }] = useMutation(EDITAR_PERIODO);

  const onAcceptChanges = (periodo) => {
    editarPeriodo({
      variables: {
        input: {
          idPeriodo: periodo.idPeriodo,
          fechaHasta: moment(periodo.fechaHasta).format()
        }
      }
    }).then(() => {
      toast.success('Período editado con éxito');
      setEditPeriodo({ periodo: null, open: false });
      getPeriodos();
    }).catch(() => {
      toast.error('Error al editar el período');
    });
  };

  const handleOpenEditModal = useCallback((periodo) => {
    setEditPeriodo({
      periodo: {
        ...periodo,
        mes: meses.find(m => m.id === periodo.mes)?.displayName || periodo.mes
      },
      open: true
    });
  }, [setEditPeriodo]);

  const handleCloseEditModal = () => {
    setEditPeriodo({ periodo: null, open: false });
  }

  const {
    periodos,
    datosOriginales,
    periodosLoading,
    totalCount,
    filters,
    handleChangeFilters,
    setPeriodos,
    getPeriodos
  } = useGetPeriodos();

  const initialColumns = [
    {
      flex: 1,
      minWidth: 40,
      maxWidth: 40,
      field: 'action',
      headerName: '',
      noPadding: true,
      renderCell: ({ row }) => {
        return (
          <div>
            <Tooltip title={!allowedWrite ? 'No tienes permisos para editar' : (!row.activo) ? 'No se puede editar un período inactivo' : 'Editar período'}>
              <IconButton onClick={() => handleOpenEditModal(row)} disabled={!allowedWrite || !row.activo}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          </div>
        )
      }
    },
    {
      flex: 80,
      field: 'idPeriodo',
      headerName: '#'
    },
    {
      flex: 160,
      field: 'mes',
      headerName: 'Mes',
      valueGetter: (mes) => {
        return meses.find((m) => m.id === mes)?.displayName || '-';
      }
    },
    {
      flex: 160,
      field: 'anio',
      headerName: 'Año'
    },
    {
      flex: 200,
      field: 'fechaDesde',
      headerName: 'FechaDesde',
      type: "date"
    },
    {
      flex: 200,
      field: 'fechaHasta',
      headerName: 'FechaHasta',
      type: "date"
    },
    {
      flex: 90,
      field: 'activo',
      headerName: 'Activo',
      renderCell: ({ row }) => {
        const { activo } = row;
        const icon = activo ?
          <CheckIcon className='icon-grid' /> :
          <ClearIcon className='icon-grid' />;
        return <Tooltip title={activo ? 'Activo' : 'Inactivo'}>{icon}</Tooltip>;
      }
    }];

  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [allowedWrite]);

  useEffect(() => {
    if (rutasStorage) {
      const rutas = JSON.parse(rutasStorage);
      const rutaQueSirve = location.pathname;

      setAllowedWrite(rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
      )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura);
    }
  }, [rutasStorage]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    handleChangeFilters(name, value);
  };

  const [consultarCierre, { data: dataCierre, loading: consultaLoading }] = useLazyQuery(CONSULTAR_CIERRE_PERIODO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataCierre) return;
    setConexionesPendientes(adaptCierrePeriodo(dataCierre));
    if (dataCierre?.consultaConexionesPeriodo?.valorEsperado[0]?.cantidad > 0) {
      toast.error('No se puede cerrar el periodo, hay conexiones activas.');
      setOpenModal(true);
    } else {
      toast.success('No se encontraton conexiones pendientes!');
      setOpenModalCierre(true);
    }
  }, [dataCierre]);

  const handleConsultarCierre = () => {
    consultarCierre();
  };

  useEffect(() => {
    if (!!filters && filters?.year !== 0) {
      const { year } = filters;
      setPeriodos(datosOriginales.filter((periodo) => periodo.anio === year));
    } else {
      setPeriodos(datosOriginales);
    }
  }, [filters, datosOriginales]);

  useEffect(() => {
    const lastInactivePeriodo = datosOriginales.
      filter((periodo) => !periodo.activo).
      reduce((closest, current) => {
        const currentFechaHasta = new Date(current.fechaHasta);
        const closestFechaHasta = new Date(closest.fechaHasta);

        return currentFechaHasta > closestFechaHasta ? current : closest;
      }, datosOriginales[0]);

    const fechaEmpalme = lastInactivePeriodo?.fechaHasta ?
      moment(lastInactivePeriodo.fechaHasta).add(1, 'days').format('YYYY-MM-DD') :
      null;

    setFechaEmpalmePeriodo(fechaEmpalme);

    setIdPeriodoActivo(datosOriginales?.find((p) => p.activo)?.idPeriodo || null);
  }, [datosOriginales]);

  const generalLoading = useMemo(() => {
    return periodosLoading || consultaLoading;
  }, [periodosLoading, consultaLoading]);

  useEffect(() => {
    const existePeriodoActivo = datosOriginales?.filter((periodo) => periodo.activo).length > 0;

    setChildrenAction(() =>
      <div className='top-buttons'>
        <GestionPeriodoCreationModal
          buttonLoading={generalLoading}
          disabledNuevo={existePeriodoActivo}
          className='button-header'
          allowedWrite={allowedWrite}
          fechaComienzo={fechaEmpalmePeriodo}
          months={meses}
          years={years}
          getPeriodos={getPeriodos} />

        <CustomButton
          isLoading={generalLoading}
          className='button-header'
          disabled={!existePeriodoActivo}
          onClick={() => handleConsultarCierre()}>

          Cerrar Periodo
        </CustomButton>
      </div>
    );
  }, [setChildrenAction,
    allowedWrite,
    datosOriginales,
    generalLoading,
    years,
    meses,
    fechaEmpalmePeriodo]
  );

  return (
    <div className='grid-container requisitos-clientes-grilla'>

      <EditPeriodoDialog
        onCancel={handleCloseEditModal}
        onAccept={onAcceptChanges}
        acceptLoading={edicionLoading}
        open={editPeriodo.open}
        periodo={editPeriodo.periodo}
      />

      <ConexionesPendientesDialog
        conexionesPendientes={conexionesPendientes}
        open={openModal}
        onClose={() => setOpenModal(false)}
        getPeriodos={getPeriodos} />

      <CerrarPeriodoDialog
        open={openModalCierre}
        onClose={() => setOpenModalCierre(false)}
        idPeriodo={idPeriodoActivo}
        getPeriodos={getPeriodos} />

      <Grid
        container
        spacing={2}
        sx={{ marginBottom: '25px' }}>

        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
          <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size='small'>
            <InputLabel id='select-area-responsable'>Año</InputLabel>
            <Select
              labelId='select-area-responsable'
              options={years}
              label='Año'
              onChange={handleChange}
              value={filters?.year || undefined}
              name='year'>

              {years.map((year) => {
                return <MenuItem key={year.id} value={year.id}> {year.displayName} </MenuItem>;
              })}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <DataGridGenerico
        columns={columns}
        totalCount={totalCount}
        rows={periodos}
        toolbar={false}
        loading={periodosLoading}
        initialState={{
          sorting: {
            sortModel: [{ field: 'idPeriodo', sort: 'desc' }]
          }
        }} />

    </div>);

};

const useGetPeriodos = () => {
  const [periodos, setPeriodos] = useState([]);
  const [datosOriginales, setDatosOriginales] = useState([]);

  const { filters, handleChangeFilters } = usePersistFilters({
    year: 1
  }, `PeriodosFilter`);

  const [getPeriodos, { data: dataPeriodos, periodosLoading }] = useLazyQuery(GET_ALL_PERIODOS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataPeriodos) return;
    setPeriodos(adaptPeriodosArray(dataPeriodos));
    setDatosOriginales(adaptPeriodosArray(dataPeriodos));
  }, [dataPeriodos]);

  useEffect(() => {
    if (periodosLoading) return;
    getPeriodos();
  }, []);

  return {
    periodos,
    datosOriginales,
    periodosLoading,
    totalCount: periodos?.length || 0,
    filters,
    handleChangeFilters,
    setPeriodos,
    getPeriodos
  };
};